import React, { Component } from "react";
import RugAPI from "../../../api/rug";

export default class RugBrands extends Component {
  // this.props.selectedBrands.indexOf(brand.id) !== -1

  constructor(props) {
    super(props);
    this.state = {
      brands: []
    };
  }

  loadBrands = () => {
    const api = new RugAPI();
    api.getRugBrands().then(response => {
      if (response.success) {
        this.setState({ brands: response.data });
      }
    });
  };

  componentDidMount() {
    this.loadBrands();
  }

  render() {
    return (
      <div
        className={
          this.props.activeFilters.indexOf("brands") !== -1
            ? "items-body"
            : "items-body active"
        }
      >
        <div className="d-grid">
          {this.state.brands.map((brand, i) => (
            <label className="filter-effect-input" key={brand + i}>
              {brand.name}
              <input
                type="checkbox"
                checked={this.props.selectedBrands.indexOf(brand.id) !== -1}
                onChange={() => this.props.changeHandler("brands", brand.id)}
              />
              <span className="checkmark"></span>
            </label>
          ))}
        </div>
      </div>
    );
  }
}
